import { render, staticRenderFns } from "./setMealOrderDet.vue?vue&type=template&id=f8619b6c&scoped=true"
import script from "./setMealOrderDet.vue?vue&type=script&lang=js"
export * from "./setMealOrderDet.vue?vue&type=script&lang=js"
import style0 from "./setMealOrderDet.vue?vue&type=style&index=0&id=f8619b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8619b6c",
  null
  
)

export default component.exports